var render = function render(){var _vm=this,_c=_vm._self._c;return _c('key-unit',{staticClass:"editor-info-editable-item",attrs:{"title":_vm.title},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',[_c('el-input',{attrs:{"placeholder":"请输入","maxlength":50,"disabled":_vm.disabled},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }